import React from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { TIDS } from "@/constants/testIds";
import { Check } from "lucide-react";

const About = () => {
  const { t } = useI18n();
  return (
    <section id="about" className="py-20 md:py-32 bg-[#F5F7FA]" data-testid={TIDS.aboutSection}>
      <div className="zdc-container">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 items-center">
          <div className="md:col-span-5">
            <div className="relative">
              <div className="aspect-[4/5] rounded-2xl overflow-hidden bg-white shadow-[0_30px_80px_rgba(17,17,17,0.08)] border border-[#E5E7EB]">
                <img
                  src="https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900"
                  alt="Fabrizio Zuin"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-[#111111] text-white rounded-2xl p-4 md:p-5 shadow-2xl">
                <div className="text-[10px] uppercase tracking-wider text-white/60">Fondatore</div>
                <div className="font-display text-base md:text-lg font-semibold">Fabrizio Zuin</div>
                <div className="text-xs text-white/70">IT Consultant</div>
              </div>
            </div>
          </div>

          <div className="md:col-span-7 space-y-6">
            <div className="text-xs font-medium uppercase tracking-[0.18em] text-[#2563EB]">
              {t.about.eyebrow}
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#111111]">
              {t.about.title}
            </h2>
            <p className="text-base md:text-lg text-[#6B7280] leading-relaxed">{t.about.text}</p>

            <ul className="space-y-3 pt-2">
              {t.about.points.map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-1 w-5 h-5 rounded-full bg-[#2563EB] flex items-center justify-center flex-shrink-0">
                    <Check className="w-3 h-3 text-white" strokeWidth={3} />
                  </span>
                  <span className="text-[15px] text-[#111111]">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
